<template>
  <main>
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-shrink-0">
        <div
          class="
            bg-indigo-400
            md:flex-shrink-0
            px-6
            py-2
            flex
            items-center
            justify-between
            md:justify-center
          "
        >
          <dropdown class="" placement="bottom-end">
            <svg
              class="fill-white w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
            <template v-slot:dropdown>
              <div class="mt-2 px-8 py-4 shadow-lg bg-indigo-100 rounded">
                <main-menu />
              </div>
            </template>
          </dropdown>
          <inertia-link class="mt-1 ml-4" href="/">
            <logo class="fill-white" width="35" height="35" />
          </inertia-link>
        </div>
        <div class="w-full bg-indigo-200 flex justify-between items-center">
          <div class="mt-1 px-4 text-xl">{{ user.account.name }}</div>
          <div id="contextMenu">To add contex menu here</div>
          <dropdown class="mt-1" placement="bottom-end">
            <div class="cursor-pointer select-none group">
              <div
                class="
                  flex
                  items-center
                  text-gray-700
                  group-hover:text-indigo-600
                  focus:text-indigo-600
                  mr-1
                  whitespace-no-wrap
                "
              >
                <icon
                  class="
                    w-10
                    h-10
                    group-hover:fill-indigo-600
                    fill-gray-700
                    focus:fill-indigo-600
                    mr-2
                  "
                  name="user-menu"
                />
                <span>{{ user.first_name }}</span>
                <span class="hidden md:inline">{{ user.last_name }}</span>
              </div>
            </div>
            <template v-slot:dropdown>
              <div class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <inertia-link
                  class="block px-6 py-2 hover:bg-indigo-500 hover:text-white"
                  :href="route('users.edit', user.id)"
                  >My Profile</inertia-link
                >
                <inertia-link
                  class="block px-6 py-2 hover:bg-indigo-500 hover:text-white"
                  :href="route('users.index')"
                  >Manage Users</inertia-link
                >
                <inertia-link
                  class="block px-6 py-2 hover:bg-indigo-500 hover:text-white"
                  :href="route('logout')"
                  method="delete"
                  >Logout</inertia-link
                >
              </div>
            </template>
          </dropdown>
        </div>
      </div>
    </div>
    <div
      class="
        max-w-3xl
        mx-auto
        md:flex-1
        px-4
        py-8
        md:p-12 md:overflow-y-auto
      "
      scroll-region
    >
      <flash-messages />

      <slot />

    </div>
  </main>
</template>

<script>
import { computed } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import Logo from "@/Shared/Logo";
import FlashMessages from "@/Shared/FlashMessages";
import MainMenu from "@/Shared/MainMenu";
import Dropdown from "@/Shared/Dropdown";

export default {
  components: {
    Icon,
    Logo,
    FlashMessages,
    MainMenu,
    Dropdown,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user);
    // console.log(user);
    return { user };
  },
};
</script>
